module.exports = __webpack_public_path__ + "img/2_4.3690b69e.png";